<template>
  <div class="getPassword">
    <login-header v-bind="headerInfo"></login-header>
    <div class="content">
      <div class="zc-tit">找回密码</div>
      <div class="zc-box zh-box">
        <ul class="dl-list">
          <li class="clearfix login-input">
            <label>手机号码</label>
            <input
              type="text"
              class="input"
              placeholder="注册时填写的手机号"
              v-model="userInfo.phone"
              id="mobile2"
              name="mobile"
            >
          </li>
          <li class="clearfix yzm login-input">
            <label>短信验证码</label>
            <input
              type="text"
              class="input"
              placeholder="验证码"
              maxlength="4"
              v-model="userInfo.codeValue"
              ref="verificationCode"
            >
            <button type="button" class="btn-yzm btn-msg2" @click="sendCode()">获取验证码</button>
          </li>
          <li class="clearfix" style="border:none">
            <div class="tips">收不到验证码？点击获取
              <a href="javascript:;" id="yzm-tips2" @click="sendCodeVms">语音验证码</a>
            </div>
            <!--<input type="password" class="input" placeholder="设置密码 " v-model="userInfo.pwd">-->
          </li>
          <input type="text" style="position: absolute; top: -999px;" />
          <li class="clearfix login-input">
            <label>设定新密码</label>
            <input
              type="password"
              class="input"
              placeholder="6~20个字，建议包含字母和数字"
              v-model="userInfo.pwd"
            >
          </li>
        </ul>
        <div class="protocol clearfix"></div>
        <button class="yellow-btn" @click="modifyPwd">立即修改</button>

        <div class="zc-bot clearfix" v-show="socialization==1">
          <div class="tool">
            <span>其他方式登录</span>
            <a href="#">
              <span class="icon icon-qq"></span>
            </a>
            <a href="#">
              <span class="icon icon-weixin"></span>
            </a>
          </div>
          <div class="zc-link">
            <span>已有账号，
              <a href="/">立即登录</a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div id="popup-captcha2"></div>
    <!--弹窗-->
    <div class="register-alert-box" :style="{display:disVal}">
      <div class="img">
        <img src="../../assets/img/warning.jpg">
      </div>
      <div class="txt">
        <p>验证码将电话通知到您，来电号码</p>
        <p>
          <em>055182190909</em>，请注意接听
        </p>
      </div>
      <div class="close" @click="closeDialog">知道了</div>
    </div>
    <div id="mask" :style="{display:disVal}" @click="closeDialog">
      <!--透明遮罩-->
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'

var sec2 = 60 // 计时器时间
var clockName2 = 'smsClock' // 计时器名称
var _method2 = 'sms'

export default {
  name: 'get-password',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '找回密码',
        userDisplayFlag: false,
        userName: '',
        logo: ''
      },
      desc: '',
      userInfo: {},
      disVal: '',
      socialization: 0,
      captchaObj: {}
    }
  },
  created() {
    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.socialization = this.loginInfo.is_master
    document.getElementsByTagName('title')[0].innerHTML = this.loginInfo.name
  },
  mounted() {
    this.initGee()
  },
  methods: {
    initGee() {
      var that = this
      QM.apinew({
        url: '/seller/account/start-gt',
        method: 'get',
        success: function(data) {
          initGeetest(
            {
              gt: data.data.gt,
              challenge: data.data.challenge,
              product: 'popup', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
              offline: !data.data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
            },
            that.handlerPopup
          )
        },
        error: function(data) {}
      })
    },
    closeDialog() {
      this.disVal = 'none'
    },
    //  拖动验证码
    clocker() {
      var html = ''
      var btn = $('.btn-msg2')
      if (sec2 > 0) {
        sec2--
        html = sec2 + '秒后重发'
        btn.addClass('on')
      } else {
        sec2 = 60
        html = '发送短信'
        btn.removeClass('on')
        clearInterval(clockName2)
      }
      btn.html(html)
    },

    handlerPopup(captchaObj) {
      this.captchaObj = captchaObj
      var that = this
      // 成功的回调
      captchaObj.onSuccess(function() {
        var validate = captchaObj.getValidate()
        QM.apinew({
          url: '/seller/account/validate-gt',
          method: 'post',
          data: {
            mobile: that.userInfo.phone,
            method: _method2,
            geetest_challenge: validate.geetest_challenge,
            geetest_validate: validate.geetest_validate,
            geetest_seccode: validate.geetest_seccode
          },
          success: function(data) {
            data.message &&
              that.$message({
                message: data.message,
                type: 'success'
              })
            if (data && data.status === true) {
              // $('#mobile2').attr('readonly', true);
              // 启用倒计时
              clockName2 = setInterval(that.clocker, 1000)
              // 弹出层
              _method2 === 'vms' && $('#mask,.register-alert-box').show()
            } else {
              that.$message(data.message)
            }
          },
          error: function(data) {
            that.$message(data.message)
          }
        })
      })
      // 将验证码加到id为captcha的元素里
      $('#popup-captcha2')[0] && captchaObj.appendTo('#popup-captcha2')
    },
    /*
     *   发送短信 new
     * */
    sendCodeVms() {
      var that = this
      /**
       * 短信发送
       */
      if (sec2 !== 60) {
        this.$message('验证码获取频繁')
        return false
      }
      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      var mobile = that.userInfo.phone
      if (!mobile_reg.test(mobile)) {
        this.$message('请输入正确的手机号')
        return false
      } else {
        _method2 = 'vms'
      }
      this.captchaObj.show()
    },
    sendCode() {
      var that = this
      /**
       * 短信发送
       */
      if (sec2 !== 60) {
        this.$message('验证码获取频繁')
        return false
      }
      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      var mobile = that.userInfo.phone
      if (!mobile_reg.test(mobile)) {
        this.$message('请输入正确的手机号')
        return false
      } else {
        _method2 = 'sms'
      }
      this.captchaObj.show()
    },
    modifyPwd() {
      var that = this
      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      if (!mobile_reg.test(that.userInfo.phone)) {
        that.$message.error('请填写正确的手机号码！')
        return
      }
      if (!that.userInfo.codeValue) {
        that.$message.error('请填写正确的验证码！')
        return
      }
      if (!that.userInfo.pwd) {
        that.$message.error('请填写密码！')
        return
      }
      QM.apinew({
        url: '/seller/account/reset-password',
        method: 'post',
        data: {
          mobile: that.userInfo.phone,
          new_password: that.userInfo.pwd,
          codeValue: that.userInfo.codeValue
        },
        success: function(xdata) {
          that.$message({
            message: xdata.message,
            type: 'success'
          })
          that.$router.push({ path: '/login.html' })
        },
        error: function(xdata) {
          that.$message.error(xdata.message)
        }
      })
    }
  }
}
</script>
<style>
input:-internal-autofill-selected {
  background-color: #ffffff !important;
  background-image: none !important;
  color: -internal-light-dark-color(black, white) !important;
}
</style>
<style scoped>
.yellow-btn:hover {
  background: #f7dd68;
}
.login-input{
  height: 62px;
  overflow: hidden;
}
</style>